<template>
  <div id="step23">
    <v-alert type="info" class="ma-0" outline :value="samples.length === 0">
      <div class="primary--text">
        Hmm, this station doesn't have any sample activities.
      </div>
    </v-alert>

    <v-card>
      <Subheader v-model="search" title="" search="sample activities" />
      <v-data-table :headers="headers" :items="samples" :search="search" :pagination.sync="pagination" item-key="id" class="elevation-1">
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left">{{ props.item.CocCode }}</td>
            <td class="text-xs-left">{{ formatDate(props.item.SampleDate, formats.prettyDateTimeFormat) }}</td>
            <td class="text-xs-left">{{ props.item.SampledBy }}</td>
            <td class="text-xs-left">{{ props.item.Notes }}</td>
            <td class="text-xs-right">
              <v-btn depressed small @click="onItemSelected(props.item)">
                {{ $t('Button.View') }}
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="1000px">
      <v-toolbar dark color="primary">
        <v-toolbar-title>{{ $t('StationDetailSampleActivity.titleMsg') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="dialog = false; isView= true" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field label="COC Code" required disabled v-model="selectedSample.CocCode"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Sample Date" disabled type="text" required v-model="selectedSample.SampleDate">
                  </v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Sampled By" v-model="selectedSample.SampledBy" :disabled="isView"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea label="Notes" v-model="selectedSample.Notes" :disabled="isView"></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-subheader style="padding-left: 0px">
                    {{ $t('StationDetailSampleActivity.subheadFirstMsg') }}
                  </v-subheader>
                  <ul style="padding-left: 20px" v-for="item in selectedSample.Documents" v-bind:key="item.Id">
                    <li>
                      <a :href="`/uploads/${item.FileName}`" download>
                        {{ item.FileName.substr(item.FileName.lastIndexOf('\\') + 1) }}</a>
                    </li>
                  </ul>
                </v-flex>
                <v-flex xs12>
                  <v-subheader style="padding-left: 0px">
                    {{ $t('StationDetailSampleActivity.subheadSecondMsg') }}
                  </v-subheader>
                  <ul style="padding-left: 20px" v-for="item in selectedSample.Imports" v-bind:key="item.id">
                    <li>
                      <a @click="viewImport(item.id)">{{item.created_at | format}}</a>
                    </li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-btn color="success" v-show="!isView" @click.native="saveSample">
              <v-icon class="mr-1">done</v-icon>
              {{ $t('Button.Save') }}
            </v-btn>
            <v-btn color="warning" v-show="isView" light @click.native="isView= false">
              <v-icon class="mr-1">edit</v-icon>
              {{ $t('Button.Edit') }}
            </v-btn>
            <v-btn color="secondary" outline v-if="!isView" @click.native="isView= true">{{ $t('Button.Cancel') }}
            </v-btn>
            <v-btn v-else color="secondary" outline @click.native="dialog = false; isView= true">
              {{ $t('Button.Close') }}</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import DataTable from '@/components/mixins/DataTable'
  import MomentUtil from '@/components/mixins/MomentUtil'

  import {
    prettyDateTimeFormat,
    formatDate,
  } from '@/components/mixins/MomentUtil'

  import {
    format,
  } from 'date-fns'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const {
    mapActions,
    mapGetters,
  } = createNamespacedHelpers('sampleactivity')

  const station = createNamespacedHelpers('stations')
  const imports = createNamespacedHelpers('imports')

  export default {
    filters: {
      format(date) {
        return format(date, 'YYYY MMM D, HH:mm')
      },
    },
    mixins: [DataTable, MomentUtil],
    props: ['name'],
    mounted() {
      if (this.stationHasPosition) {
        this.currentPosition.lat = this.stationData.position.lat
        this.currentPosition.lng = this.stationData.position.lng
      }
    },
    data() {
      return {
        formats: {
          prettyDateTimeFormat,
        },
        dialog: false,
        selectedSample: {},
        search: '',
        headers: [{
          text: 'COC Code',
          align: 'left',
          value: 'CocCode',
        },
        {
          text: 'Sample Date',
          value: 'SampleDate',
        },
        {
          text: 'Sampled By',
          value: 'SampledBy',
        },
        {
          text: 'Notes',
          value: 'Notes',
        },
        {
          text: '',
          value: '',
          sortable: false,
        },
        ],
        isView: true,
        layer: null,
        currentPosition: {
          lat: 59.0,
          lng: -130.0,
        },
        pagination: {
          sortBy: 'CocCode',
          rowsPerPage: 10,
        },
      }
    },
    computed: {
      ...mapGetters(['samples']),
      ...station.mapGetters(['distinctStations']),
      ...imports.mapGetters(['importlist']),
      stationData() {
        return this.distinctStations.find(x => x.name == this.name)
      },
      stationHasPosition() {
        return this.stationData != null && this.stationData.position != null && this.stationData.position.lat != null
      },
    },
    methods: {
      ...mapActions(['updateSample']),
      formatDate,
      viewImport(id) {
        let routeData = this.$router.resolve('/import/' + id)
        window.open(routeData.href, '_blank')
      },
      onItemSelected(item) {
        this.dialog = true
        this.selectedSample = JSON.parse(JSON.stringify(item))
        this.selectedSample.SampleDate = this.formatDateTime(item.SampleDate)
        this.selectedSample.Imports = this.getImportsOfSample(item.CocCode)
      },
      saveSample() {
        this.updateSample(this.selectedSample).then(() => {
          this.dialog = false
          this.isView = true
        })
      },
      getImportsOfSample(cocCode) {
        return this.importlist.filter(x => x.coc_code == cocCode)
      },
    },
  }
</script>
<style>
  a {
    cursor: pointer;
    text-decoration: underline;
  }

  /* #map { height: 600px; } */
</style>